export { default } from './Loader';



// WEBPACK FOOTER //
// ./src/components/Loader/index.js